import { __decorate } from "tslib";
import { attr, FASTElement, nullableNumberConverter, observable, } from "@microsoft/fast-element";
import { MsftContentIndicator } from "../content-indicator";
export var ContentCardLayout;
(function (ContentCardLayout) {
    ContentCardLayout["default"] = "default";
    ContentCardLayout["condensed"] = "condensed";
    ContentCardLayout["infoPane"] = "infoPane";
    ContentCardLayout["infoPane1x3y"] = "infoPane1x3y";
    ContentCardLayout["infoPaneSplitVertical"] = "infoPaneSplitVertical";
    ContentCardLayout["infoPaneSplitHorizontal"] = "infoPaneSplitHorizontal";
})(ContentCardLayout || (ContentCardLayout = {}));
export class ContentCard extends FASTElement {
    constructor() {
        super(...arguments);
        this.layout = ContentCardLayout.default;
        this.headinglevel = 3;
    }
    handleStartActionsContentChange() {
        this.startActionsContainer.classList.toggle("start-actions", this.startActions.assignedNodes().length > 0);
        this.hasFooter = this.endActions.assignedNodes().length > 0;
    }
    handleEndActionsContentChange() {
        this.endActionsContainer.classList.toggle("end-actions", this.endActions.assignedNodes().length > 0);
        this.hasFooter = this.endActions.assignedNodes().length > 0;
    }
    abstractChanged() {
        if (this.$fastController.isConnected) {
            this.hasAbstract = this.abstract.length > 0;
        }
    }
    handleMediaContentChange() {
        this.mediaContainer.classList.toggle("media", this.media.assignedNodes().length > 0);
    }
    handleBackgroundImageContentChange() {
        this.backgroundImageContainer.classList.toggle("background-image", this.backgroundImage.assignedNodes().length > 0);
    }
    handleContentCardLinkClick(e) {
        this.$emit("link-invoked", e);
        // return true to ensure default is not prevented
        // https://www.fast.design/docs/fast-element/declaring-templates/#events
        return true;
    }
    /**
     * @internal
     */
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener("mouseover", this.mouseOver);
        this.addEventListener("mouseout", this.mouseOut);
        this.addEventListener("focusin", this.focusIn);
        this.addEventListener("focusout", this.focusOut);
    }
    /**
     * @internal
     */
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("mouseover", this.mouseOver);
        this.removeEventListener("mouseout", this.mouseOut);
        this.removeEventListener("focusin", this.focusIn);
        this.removeEventListener("focusout", this.focusOut);
    }
    mouseOver() {
        this.setExpanded(true);
        this.hasHover = true;
    }
    mouseOut() {
        if (!this.hasFocus) {
            this.setExpanded(false);
        }
        this.hasHover = false;
    }
    focusIn() {
        this.setExpanded(true);
        this.hasFocus = true;
    }
    focusOut() {
        if (!this.hasHover) {
            this.setExpanded(false);
        }
        this.hasFocus = false;
    }
    filteredContentIndicator() {
        return this.contentIndicatorNodes.filter((contentIndicator) => {
            return contentIndicator instanceof MsftContentIndicator;
        });
    }
    setExpanded(expanded) {
        this.filteredContentIndicator().forEach(item => (item.expanded = expanded));
    }
}
__decorate([
    attr
], ContentCard.prototype, "layout", void 0);
__decorate([
    attr({
        attribute: "heading-level",
        mode: "fromView",
        converter: nullableNumberConverter,
    })
], ContentCard.prototype, "headinglevel", void 0);
__decorate([
    attr({
        mode: "fromView",
    })
], ContentCard.prototype, "href", void 0);
__decorate([
    observable
], ContentCard.prototype, "anchorTelemetryTag", void 0);
__decorate([
    observable
], ContentCard.prototype, "mediaNodes", void 0);
__decorate([
    observable
], ContentCard.prototype, "hasAbstract", void 0);
__decorate([
    observable
], ContentCard.prototype, "hasFooter", void 0);
__decorate([
    observable
], ContentCard.prototype, "abstract", void 0);
__decorate([
    observable
], ContentCard.prototype, "iconSlottedNodes", void 0);
__decorate([
    attr({
        attribute: "image-priority",
        mode: "boolean",
    })
], ContentCard.prototype, "imagePriority", void 0);
__decorate([
    attr
], ContentCard.prototype, "target", void 0);
__decorate([
    observable
], ContentCard.prototype, "hoverActionsSlottedNodes", void 0);
__decorate([
    observable
], ContentCard.prototype, "contentIndicatorNodes", void 0);
